const BASE64_PREFIX = "data:image/png;base64,";

export const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(new Error(error?.message || 'Failed to read file'));
    });
};
export const uploadImage = async (file, base64Key, createFn, refreshFn) => {
    const base64Image = await convertToBase64(file);
    const payload = {
        UserID: localStorage.getItem('user_id'),
        [base64Key]: base64Image.substring(BASE64_PREFIX.length),
    };
    await createFn(payload);
    await refreshFn();
};
